export default __webpack_public_path__ + "099a9556e1a63ece24f8a99859c94c7d.woff";